import { AvatarGroup, Box, styled } from '@mui/material';

import type { AvatarSizeEnum } from '@shared/enums/avatarSize.enum';

export const AvatarGroupContainer = styled(AvatarGroup, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{
  size: AvatarSizeEnum;
}>(({ size, theme }) => ({
  cursor: 'pointer',
  '& .MuiAvatarGroup-avatar': {
    width: size || '30px',
    height: size || '30px',
    boxSizing: 'border-box',
    fontSize: theme.typography.t12m.fontSize,
    fontWeight: theme.typography.t12m.fontWeight,
    color: theme.palette.case.neutral.n800,
    backgroundColor: theme.palette.case.primary.p50,
    border: `1px solid ${theme.palette.case.primary.p100}`,
    marginLeft: '-7px',
  },
}));

export const AvatarGroupContentContainer = styled(Box, {
  shouldForwardProp: (prop: string) => !['isUsersListWithOwner'].includes(prop),
})<{ isUsersListWithOwner: boolean }>(({ isUsersListWithOwner }) => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: isUsersListWithOwner ? '8px' : '0px',
}));

export const LoadingConfirmShareContainer = styled(Box, {
  shouldForwardProp: (prop: string) => !['isUsersListWithOwner'].includes(prop),
})<{ isUsersListWithOwner: boolean }>(({ isUsersListWithOwner }) => ({
  marginLeft: isUsersListWithOwner ? '8px' : '0px',
}));
